<template>
    <section :id="`element-${settings.id}`" class="elle-instagram padd-v" :style="{ backgroundColor: settings?.color }">
        <div class="container">
            <div class="grid12">
                <div class="l-col">
                    <UiHeadline
                        :settings="{
                            label: settings?.label,
                            headline: settings?.headline
                        }"
                    />
                </div>
                <div class="m-col">
                    <div v-if="settings?.linkUrl.length" class="buttons">
                        <UiLink :link="settings.linkUrl[0]" :style="'transparent w-border'" />
                    </div>
                </div>
                <div v-if="status == 'success'" class="r-col">
                    <div v-show="isDesktop" class="elle-instagram--wrapper">
                        <div :class="[settings?.amount ? 'grid6' : 'grid4']">
                            <CardsInstagram v-for="item in items" :key="item.id" :post="item" />
                        </div>
                    </div>
                    <UiSliderMobile v-show="!isDesktop" :classes="''">
                        <template #sliders>
                            <swiper-slide v-for="item in items" :key="item.id" class="swiper-slide">
                                <CardsInstagram :post="item" />
                            </swiper-slide>
                        </template>
                    </UiSliderMobile>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        settings?: CmsItem;
    }>(),
    {
        settings: () => ({})
    }
);

const settings = computed(() => props.settings);

const { data: instagram, status } = await useAsyncGql({
    operation: 'instagram',
    variables: {
        hash: settings.value?.hash || 'elle_midwives',
        limit: settings.value?.amount ? 6 : 4
    }
});

const items = computed<CmsItem[]>(() => ((instagram.value?.instagram as CmsItem[] | null) ?? []).filter(Boolean));
const isDesktop = useMediaQuery('(min-width: 768px)');
</script>
